module.exports = __webpack_public_path__ + "static/media/quintil.c99242c5.png";